import { jsx as _jsx } from "react/jsx-runtime";
import { LogoDarkest, LogoNeutralDark, LogoNeutralWhite, LogoPrimary, LogoSecondary } from "./styles";
export function Logo({ type, ...rest }) {
    switch (type) {
        case "darkest":
            // @ts-ignore
            return _jsx(LogoDarkest, { ...rest });
        case "neutral_dark":
            // @ts-ignore
            return _jsx(LogoNeutralDark, { ...rest });
        case "neutral_white":
            // @ts-ignore
            return _jsx(LogoNeutralWhite, { ...rest });
        case "secondary":
            // @ts-ignore
            return _jsx(LogoSecondary, { ...rest });
        default:
            // @ts-ignore
            return _jsx(LogoPrimary, { ...rest });
    }
}
//# sourceMappingURL=index.js.map